import { Company } from './company';

export class Supplier extends Company {
  company?: Company = null;
  type = 'supplier';
  saasName?: string;

  constructor() {
    super();
  }
}
